export default __webpack_public_path__ + "static/media/@3x_case_4(780_830).089e76ea.png";